import React from "react";
import MasterDataFormV2 from "pages/POS/MasterDataFormV2";
import PrintJson from "utils/printJson";

const WarehouseForm = ({ initialData, onSuccess, onError }) => {
  return (
    <>  
    <MasterDataFormV2
      title="Warehouse"
      apiUrl="/warehouses"
      initialData={initialData}
      fields={[
        {
          name: "name",
          label: "Warehouse Name",
          type: "text",
          required: true,
          placeholder: "Enter warehouse name",
          maxLength: 100,
        },
        {
          name: "code",
          label: "Warehouse Code",
          type: "text",
          required: true,
          placeholder: "Enter warehouse code (e.g., PTI)",
          maxLength: 10,
        },
        {
          name: "type",
          label: "Warehouse Type",
          type: "text",
          required: true,
          placeholder: "Select warehouse type",
        },
        {
          name: "address",
          label: "Address",
          type: "textarea",
          required: true,
          placeholder: "Enter complete warehouse address",
          maxLength: 500,
        },
        {
          name: "manager_id",
          label: "Manager",
          type: "text",
          required: false,
          placeholder: "Enter manager ID or name",
        },
        {
          name: "is_active",
          label: "Status",
          type: "select",
          required: true,
          options: [
            { value: 1, label: "Active" },
            { value: 0, label: "Inactive" },
          ],
        },
        {
          name: "description",
          label: "Description",
          type: "textarea",
          required: false,
          placeholder: "Enter warehouse description",
          maxLength: 1000,
        },
      ]}
      onSuccess={onSuccess}
      onError={onError}
    />
    <PrintJson data={initialData} title="Initial Data:" />
    </>
  );
};

export default WarehouseForm;
